export const isSequential = (value: string, max: number): boolean => {
  let count = 1;

  for (let i = 0; i < value.toLowerCase().length; i++) {
    const char = value[i];
    const nextChar = value[i + 1];

    if (!nextChar) {
      break;
    }

    const code = char.charCodeAt(0);
    const nextCode = nextChar.charCodeAt(0);
    const diff = code - nextCode;

    if (Math.abs(diff) === 1) {
      count++;
    } else {
      count = 1;
    }

    if (count > max) {
      return false;
    }
  }

  return true;
};
